/**
 * Allow only same-app relative paths for post-login / OAuth return URLs.
 * Rejects absolute URLs, protocol-relative `//…`, and schemes like `javascript:`.
 */
export function safeReturnUrl(input, fallback = "") {
  const raw = input == null ? "" : String(input).trim();
  if (!raw) return fallback;
  if (raw.startsWith("//") || raw.includes("\\")) return fallback;
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(raw)) return fallback;
  if (!raw.startsWith("/")) return fallback;
  return raw;
}
